import { ProjectStatusMultiSelectValue } from '@components/Projects/Shared/ProjectStatusMultiSelect'
import { RecurringStatus, Status } from '@lib/graphql/__generated__/graphql'
import { TFunction } from '@translations/useTranslations'

export const ENTITY_STATUS: Record<string, Status | string> = {
  NOT_STARTED: Status.New,
  IN_PROGRESS: Status.InProgress,
  DONE: Status.Done,
  CANCELED: Status.Canceled,
}

export const EntityStatusFilter = (t: TFunction) => {
  return [
    { label: t('statusFilter.new'), value: ENTITY_STATUS.NOT_STARTED },
    { label: t('statusFilter.inProgress'), value: ENTITY_STATUS.IN_PROGRESS },
    { label: t('statusFilter.done'), value: ENTITY_STATUS.DONE },
    { label: t('statusFilter.canceled'), value: ENTITY_STATUS.CANCELED },
  ]
}

export const getEntityStatusMeta = (t?: TFunction) => {
  const entityStatusMeta = {
    [ENTITY_STATUS.NOT_STARTED]: {
      key: ENTITY_STATUS.NOT_STARTED,
      value: t?.('status.new'),
      icon: 'text-lg far fa-sticky-note text-oxford-gray-400',
    },
    [ENTITY_STATUS.IN_PROGRESS]: {
      key: ENTITY_STATUS.IN_PROGRESS,
      value: t?.('status.inProgress'),
      icon: 'text-lg far fa-redo-alt fa-flip-horizontal fa-flip-vertical text-cornflower-blue-400',
    },
    [ENTITY_STATUS.DONE]: {
      key: ENTITY_STATUS.DONE,
      value: t?.('status.done'),
      icon: 'text-lg far fa-check text-jade-500',
    },
    [ENTITY_STATUS.CANCELED]: {
      key: ENTITY_STATUS.CANCELED,
      value: t?.('status.canceled'),
      icon: 'text-lg far fa-ban text-watermelon-800',
    },
  }

  return entityStatusMeta
}

export const getEntityStatusDropdownValues = (
  t?: TFunction,
): ProjectStatusMultiSelectValue[] => [
  {
    key: Status.New,
    value: t?.('status.new'),
  },
  {
    key: Status.InProgress,
    value: t?.('status.inProgress'),
  },
  {
    key: Status.Done,
    value: t?.('status.done'),
  },
  {
    key: Status.Canceled,
    value: t?.('status.canceled'),
  },
]

export const COMPLETED_STATUSES = [ENTITY_STATUS.DONE, ENTITY_STATUS.CANCELED]

export const getRecurringDefinitionStatusMeta = (t?: TFunction) => {
  const recurringDefinitionStatusMeta = {
    [RecurringStatus.InProgress]: {
      key: RecurringStatus.InProgress,
      value: t?.('status.inProgress'),
      icon: 'text-lg far fa-redo-alt fa-flip-horizontal fa-flip-vertical text-cornflower-blue-400',
    },
    [RecurringStatus.Paused]: {
      key: RecurringStatus.Paused,
      value: t?.('status.paused'),
      icon: 'text-lg far fa-pause text-cornflower-blue-400',
    },
    [RecurringStatus.Finished]: {
      key: RecurringStatus.Finished,
      value: t?.('status.finished'),
      icon: 'text-lg far fa-check text-jade-500',
    },
  }

  return recurringDefinitionStatusMeta
}
